import React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * Switches ?bank=question | ?bank=mock for admin upload / review / staging flows.
 */
const AdminBankModeTabs = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const bank = params.get("bank") === "mock" ? "mock" : "question";

    const handleChange = (_e, next) => {
        const nextParams = new URLSearchParams(location.search);
        if (next === "mock") {
            nextParams.set("bank", "mock");
        } else {
            nextParams.delete("bank");
        }
        const qs = nextParams.toString();
        navigate(`${location.pathname}${qs ? `?${qs}` : ""}`, { replace: true });
    };

    return (
        <Box sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={bank} onChange={handleChange}>
                <Tab label="Question bank" value="question" />
                <Tab label="Mock bank" value="mock" />
            </Tabs>
        </Box>
    );
};

export default AdminBankModeTabs;
